function Rainbow() {
  return (
    <>
      <h2 id="rainbow">Rainbow Scratch (2012)</h2>
      <p>
        A simple program I made in Processing, inspired by rainbow scratch
        paper. The screen is initially black. By pressing R, G or B and dragging
        the mouse, a colourful gradient is drawn. Holding down R, G or B
        activates the large brush size. Holding E will erase what is drawn.
        Pressing S will save a screenshot in the same folder as the program.
      </p>
      <p>
        The project files are{" "}
        <a
          href="https://1drv.ms/u/s!Arlw0YD7zqYNhma8R6lgTuttDNX2"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        .
      </p>
      <img
        alt="rainbow"
        src="https://1drv.ms/i/c/0da6cefb80d170b9/UQS5cNGA-86mIIANkSYAAAAAAAicC4EDHrIhjJE?width=800&height=800"
      />
      <div>A donut drawn in my program.</div>
    </>
  );
}

export default Rainbow;
